import { Flex, Inline, xcss } from '@atlaskit/primitives';
import React from 'react';

const elementBeforeIconWrapper = xcss({
  marginRight: 'space.negative.075',
});

/**
 * A shared component for the context menu items with fixed margin.
 */
export const ElementBeforeIconWrapper = ({ children }: { children: React.ReactNode }) => {
  return <Flex xcss={elementBeforeIconWrapper}>{children}</Flex>;
};

const elementAfterShortCutWrapper = xcss({
  backgroundColor: 'color.background.neutral',
  color: 'color.text.subtlest',
  borderRadius: 'radius.xsmall',
  padding: 'space.050',
  font: 'font.body.small',
  alignSelf: 'flex-end',
});

/**
 * A shared component for the context menu items with fixed styles.
 */
export const ElementAfterShortCutWrapper = ({
  tooltip,
}: {
  tooltip: string | undefined;
}) => {
  return <Inline xcss={elementAfterShortCutWrapper}>{tooltip}</Inline>;
};
